export default {
  name: 'Content section - 5',
  tab: 'content',
  type: 'content-default-section',
  content: {
    title: 'Content section',
    introtext:
      '<p>Donec id elit non mi porta gravida at eget metus. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.</p>',
    image: null,
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/luca-bravo-A-fubu9QJxE-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-dark-color)',
    'title-font-weight': 'lighter',
    'title-tag': 'h2',
    'introtext-color': 'var(--text-dark-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'center',
    'content-box': '1',
    'content-box-color': 'var(--accent-color)',
    'content-box-padding': '60px',
    'content-box-opacity': '1',
    'content-box-elevation': '8',
    'content-box-border': '0',
    'content-box-border-color': 'inherit',
    'content-box-rounded': '1'
  },
  advanced: {}
}
